import { useState, useCallback, useContext, useEffect, forwardRef, useRef } from "react";
import Link from 'next/link'
import { useRouter } from "next/router";
import cName from 'classnames';
import { Popover, Row, Col, Button, Input, SideSheet, Tree } from '@douyinfe/semi-ui';

import { IndexContext } from "@/stores/index";

import styles from "./styles.module.scss";

import { useTranslations } from "next-intl";

const MenuItemChild = forwardRef(({ item, current, ...restProps }: any, ref) => {
  return (
    <li ref={ref} {...restProps} id={`item_${item?.id}`} className={cName([styles.item, (item?._href == current?._href || item?.id == current?.pid) && styles.active])} >
      <Link href={item?._href || '/'}>
        <a className={styles.link} target={item?._target || '_self'}>{item._title}</a>
      </Link>
      {/* seo优化 */}
      <ul style={{ display: 'none' }}>
        {
          item?.childlist?.map((child: any) => (
            <li key={child?.id}>
              <Link href={child?._href || '/'}>
                <a target={child?._target || '_self'}>{child._title}</a>
              </Link>
            </li>
          ))
        }
      </ul>
    </li>
  )
})

export default ({ }) => {
  const router = useRouter()
  const t = useTranslations("header");

  const { menu, menuCurrent, menuParent, expo } = useContext(IndexContext);

  const difference = String(Math.ceil((expo.start_time * 1000 - Date.now()) / (1000 * 60 * 60 * 24)));

  const [isShowSearch, setIsShowSearch] = useState<boolean>(false)
  const [isShowMenu, setIsShowMenu] = useState<boolean>(false)
  const [headerHeight, setHeaderHeight] = useState<number>(0)

  const getHeaderHeight = () => {
    let headerWrap = document.getElementById('header-wrap')
    setHeaderHeight(headerWrap?.clientHeight || 0)
  }

  useEffect(() => {
    getHeaderHeight()
    window.addEventListener('resize', getHeaderHeight);
    return () => {
      window.removeEventListener('resize', getHeaderHeight);
    };
  }, [])

  const changeLang = useCallback((locale: 'cn' | 'en') => {
    router.push(router.asPath, router.asPath, { locale })
  }, [router])
  const getTreeData = useCallback((data: any) => {
    return data?.map((item: any) => {
      return {
        label: item?._title,
        key: String(item?.id),
        children: getTreeData(item?.childlist || []),
        ...item
      }
    })
  }, [])
  const renderFullLabel = useCallback(({ className, data, expandIcon, onClick, onExpand }: any) => {
    const isLeaf = !(data.children && data.children.length);
    return (
      <li className={className} role="treeitem" onClick={isLeaf ? onClick : onExpand}>
        {isLeaf ? null : expandIcon}
        <span>{data?.label}</span>
      </li>
    )
  }, [])
  const gotoPage = useCallback((item: any) => {
    setIsShowMenu(false)
    if (item?._target == "_blank") {
      window.open(item?._href, '_blank');
    } else {
      router.push(item?._href, item?._href, {});
    }
  }, [])
  const [keywords, setKeywords] = useState('')
  const search = useCallback(() => {
    setIsShowSearch(false)
    const _url = `/search?kw=${keywords || ''}`
    router.push(_url, _url, {});
  }, [keywords])

  return (
    <header className={styles.header} style={{ height: `${headerHeight}px` }}>
      <div id="header-wrap" className={styles.wrap}>
        <div className={styles.inner}>
          <div className={cName([styles.top])}>
            <Link href="/">
              <a className={styles.title}>{t("title")}</a>
            </Link>
            <p className={styles.date}>{t("date")}</p>
            <p className={styles.address}>{t("address")}</p>
            <div className={styles.countdown}>
              <span>{t("countdown_prefix")}</span>
              {
                difference.split('').map((num: string, index: number) => (
                  <span key={index} className={styles.num} >{num}</span>
                ))
              }
              <span>{t("countdown_suffix")}</span>
            </div>
            <div className={styles.language}>
              {/* <span>语言：</span> */}
              <a className={cName(router.locale == "cn" && styles.active)} onClick={() => changeLang('cn')}>中文</a>
              <span>&nbsp;&nbsp;/&nbsp;&nbsp;</span>
              <a className={cName(router.locale == "en" && styles.active)} onClick={() => changeLang('en')}>EN</a>
            </div>
            <button className={styles.search} onClick={() => setIsShowSearch(!isShowSearch)}>
              <img src="/image/search.png" alt="" />
            </button>
            <img className={styles.nav} src="/image/menu.png" alt="" onClick={() => setIsShowMenu(!isShowMenu)} />
          </div>
        </div>
        <div className={styles.inner}>
          <div className={cName([styles.middle])}>
            <Link href="/">
              <a className={styles.logo}>
                <img src="/image/footer-logo-2027.png" alt="logo" />
              </a>
            </Link>
            <ul className={styles.menu}>
              {
                menu?.map((item: any) => (
                  item?.childlist?.length > 0
                    ? <Popover
                      key={item?.id}
                      content={
                        <ul className={styles.childs}>
                          {
                            item?.childlist?.map((child: any) => (
                              <li key={child?.id} className={styles.child}>
                                <Link href={child?._href || '/'}>
                                  <a target={child?._target || '_self'}>{child._title}</a>
                                </Link>
                              </li>
                            ))
                          }
                        </ul>
                      }
                      getPopupContainer={() => document.getElementById(`item_${item?.id}`) as HTMLElement}
                      showArrow={true}
                      trigger="hover"
                    >
                      <MenuItemChild item={item} current={menuCurrent} />
                    </Popover>
                    : <MenuItemChild key={item?.id} item={item} current={menuCurrent} />
                ))
              }
            </ul>
            <div className={styles.btns}>
              <Link href="/exhibition/apply">
                <a className={styles.btn}>
                  <div className={styles.slider} dangerouslySetInnerHTML={{ __html: t('btn1') }}></div>
                  <div className={styles.icon}>{'>'}</div>
                </a>
              </Link>
              <Link href={router.locale == "cn" ? "https://cbce2025.expotec-group.com/?member/register&code=sites" : "https://cbce2025.expotec-group.com/?member/register&lang=en"}>
                <a className={cName([styles.btn, styles.white])} target="_blank">
                  <div className={styles.slider} dangerouslySetInnerHTML={{ __html: t('btn2') }}></div>
                  <div className={styles.icon}>{'>'}</div>
                </a>
              </Link>
            </div>
          </div>
        </div>
        <div className={cName([styles.bottom, isShowSearch && styles.show])}>
          <div className={styles.searchBox}>
            <Row gutter={20}>
              <Col sm={20} xs={18}>
                <Input
                  className={styles.input}
                  placeholder={t("search_placeholder")}
                  value={keywords}
                  onChange={(e: any) => setKeywords(e)}
                />
              </Col>
              <Col sm={4} xs={6}>
                <Button className={styles.button} htmlType="submit" onClick={search}>
                  {t("search_btn")}
                </Button>
              </Col>
            </Row>
          </div>
        </div>
        <SideSheet title={t("title")} placement="left" visible={isShowMenu} width="75%" onCancel={() => setIsShowMenu(false)}>
          <Tree
            treeData={getTreeData(menu)}
            renderFullLabel={renderFullLabel}
            onSelect={(selectedKey: string, selected: boolean, selectedNode: any) => {
              gotoPage(selectedNode)
            }}
          />
        </SideSheet>
        <style jsx global lang='scss'>
          {
            `
              .semi-portal{
                z-index: 10000 !important;
              }
              .semi-sidesheet-title{
                width:80%;
              }
              .semi-tree-option{
                padding:8px 12px !important;
              }
            `
          }
        </style>
      </div>
    </header >
  );
};
